<template>
	
	<div class="inputSections" :class="pageTheme">
		<h1 v-if="section.title">{{ section.title }}</h1>
		<p v-if="section.subtitle" v-html="section.subtitle"></p>
		<div v-for="f in section.fields" :key="f">
			<v-text-field v-if="['password'].includes(f.type.toLowerCase())"
				v-model="f.value"
				:type="showPasswords ? 'text' : 'password'"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				autocomplete="new-password"
				:append-icon="showPasswords ? 'mdi-eye' : 'mdi-eye-off'"
				@click:append="showPasswords = !showPasswords"
				:clearable="!determineDisabled(f)"
				@change="handlePasswordKeyup(f)"
				@keyup="handlePasswordKeyup(f)"
				@keydown="handleKeydown(f, $event)"
				@click:clear="f.strongPass = false"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''; f.strongPass = false" /></template>
			</v-text-field>
			<p v-if="['password'].includes(f.type.toLowerCase()) && !f.strongPass && f.value" class="small" style="color: red; margin-top: -15px;">Weak Password</p>
			<p v-if="['password'].includes(f.type.toLowerCase()) && f.strongPass" class="small" style="color: #00ff00; margin-top: -15px;">Strong Password</p>
			<p v-if="['password'].includes(f.type.toLowerCase())" class="small">Passwords must be at least 8 characters, contain at least one upper case character, at least one lower case character, a number and a special character, such as one of the following: !@#$%&*?</p>
			
			<v-text-field v-if="['number', 'text', 'email'].includes(f.type.toLowerCase())"
				v-model="f.value"
				:type="f.type"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				autocomplete="new-email"
				:clearable="!determineDisabled(f)"
				@keydown="handleKeydown(f, $event)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<v-text-field v-if="['accountnumber'].includes(f.type.toLowerCase())"
				v-model="f.value"
				type="text"
				inputmode="numeric"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				:clearable="!determineDisabled(f)"
				@keydown="handleKeydown(f, $event)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<v-text-field v-if="['currency'].includes(f.type.toLowerCase())"
				v-model="f.value"
				type="text"
				inputmode="decimal"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				prefix="£"
				placeholder="0.00"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				:clearable="!determineDisabled(f)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<v-text-field v-if="['percent'].includes(f.type.toLowerCase())"
				v-model="f.value"
				type="number"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				suffix="%"
				placeholder="0"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				:clearable="!determineDisabled(f)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<div v-if="f.type == 'select'" class="select-radio-group">
				<p class="radio-label">{{ f.label }} {{ f.required ? '*' : '' }}</p>
				<v-radio-group v-model="f.value" inline :disabled="determineDisabled(f)">
					<v-radio v-for="i in f.items" :key="i" :label="i" :value="i"></v-radio>
				</v-radio-group>
			</div>
			<FieldDrawer v-if="f.type == 'dropdown' && !manualEntryFields[f.id]"
				v-model="f.value"
				:label="f.label"
				:items="f.items"
				:required="f.required"
				:disabled="determineDisabled(f)"
				:clearable="!determineDisabled(f)"
				:subtitle="f.drawerSubtitle"
				:notListedText="f.notListedMessage ? f.notListedMessage + (f.notListedAction ? '' : '') : null"
				:showAvatars="f.showAvatars === true"
				:theme="pageTheme"
			/>
			<v-text-field v-if="f.type == 'dropdown' && manualEntryFields[f.id]"
				v-model="f.value"
				type="text"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				:clearable="!determineDisabled(f)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<DateFieldDrawer v-if="f.type == 'date' || f.type.toLowerCase() == 'datetext'"
				v-model="f.value"
				:label="f.label"
				:required="f.required"
				:disabled="determineDisabled(f)"
				:clearable="!determineDisabled(f)"
				:theme="pageTheme"
			/>
			<v-text-field v-if="['sortcode'].includes(f.type.toLowerCase())"
				v-model="f.value"
				:type="f.type"
				:label="f.label + ' ' + (f.required ? '*' : '')"
				:variant="fieldVariant"
				:disabled="determineDisabled(f)"
				:flat="fieldFlat"
				:clearable="!determineDisabled(f)"
				@keyup="handleKeyup(f, $event)"
				@keydown="handleKeydown(f, $event)"
				:bg-color="determineColour(f)"
			>
				<template #clear><img :src="require('@/assets/clearx.png')" class="clear-x" @click="f.value = ''" /></template>
			</v-text-field>
			<div v-if="['radio'].includes(f.type.toLowerCase())">
				<p>{{ f.label }}:</p>
				<v-radio-group v-model="f.value" inline>
					<v-radio v-for="i in f.items" :key="i" :label="i" :value="i"></v-radio>
				</v-radio-group>
			</div>
			<v-checkbox class="check" v-if="f.type == 'check'"
				v-model="f.value"
				:label="f.label"
				:bg-color="determineColour(f)" 
			/>
			<AddressLookup v-if="f.type == 'address'" 
				:theme="pageTheme" 
				:showNumber="false" 
				:value="f.value"
				v-model="f.value"
			/>
			<div class="small centered" v-if="f.link"><a :href="f.link">{{ f.linkLabel }}</a></div>
			<p v-if="f.subtitle" class="small">{{ f.subtitle }}</p>
			<p v-if="f.helpText" class="help-text">{{ f.helpText }}</p>
			<div v-if="f.notListedMessage && !manualEntryFields[f.id] && !f.value" class="not-listed">
				<p>{{ f.notListedMessage }}</p>
				<a v-if="f.notListedAction" @click="enableManualEntry(f)">{{ f.notListedAction }}</a>
			</div>
			<div v-if="f.notListedMessage && manualEntryFields[f.id]" class="not-listed not-listed--manual">
				<p v-if="f.notListedActionedMessage">{{ f.notListedActionedMessage }}</p>
				<a @click="disableManualEntry(f)">Back to list</a>
			</div>
		</div>
	</div>
	
</template>

<script>

import AddressLookup from './AddressLookup.vue';
import FieldDrawer from './FieldDrawer.vue';
import DateFieldDrawer from './DateFieldDrawer.vue';

export default {
	name: "InputSections",
	components: { AddressLookup, FieldDrawer, DateFieldDrawer },
	props: {
		formatter: {
			type: Object,
			default: () => ({})
		},
		sections: {
			type: Array,
			required: true
		},
		theme: {
			type: String,
			required: true
		},
		editMode: {
			type: Boolean,
			default: false
		},
		outline: {
			type: Boolean,
			default: false
		}
	},
	emits: ['notListedAction'],
	data() {
		return{
			sectionNo: 0,
			lastSectionNo: 0,
			pageTheme: this.theme,
			showPasswords: false,
			manualEntryFields: {},
		}
	},
	computed: {
		section() {
			return this.sections[this.sectionNo];
		},
		fieldVariant() {
			return this.outline ? 'outlined' : 'solo';
		},
		fieldFlat() {
			return !this.outline;
		}
	},
	methods: {
		onLoad() {
			if (!this.pageTheme) { this.pageTheme = 'dark'; }
		},
		determineColour(field) {
			if (this.pageTheme == 'white') {
				return '#ffffff';
			} else if (this.pageTheme == 'dark') {
				return '#ffffffaa';
			} else {
				if (field.readOnly && this.editMode) {
					return '#ffffffaa';
				} else {
					return '#3328470D';
				}
			}
		},
		next(sectionNumber) {
			this.sectionNo = sectionNumber;
		},

		back(sectionNumber)	{
			this.sectionNo = sectionNumber;
		},
		handlePasswordKeyup(field) {
			var strongPass = false;
			if (field.value && field.value.length > 0) {
				strongPass = field.value.length > 7;
				if (strongPass) {
					strongPass = /[A-Z]/.test(field.value) && /[a-z]/.test(field.value) && /\d/.test(field.value) && /[!@#$%^&*(),.?":{}|<>]/.test(field.value);
				}
			}
			field.strongPass = strongPass;
		},
		handleKeyup(field, event) {
			const type = field.type.toLowerCase();
			if (type === 'datetext' && event.key !== 'Backspace' && field.value && (field.value.length == 2 || field.value.length == 5)) {
				field.value += '/';
			} else if (type === 'sortcode' && event.key !== 'Backspace' && field.value && (field.value.length == 2 || field.value.length == 5)) {
				field.value += '-';
			}
		},
		handleKeydown(field, event) {
			const type = field.type.toLowerCase();
			if (['datetext', 'sortcode', 'currency', 'percent', 'accountnumber'].includes(type)) {
				if (!/[0-9]/.test(event.key) && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight' && (type !== 'currency' && type !== 'percent' || event.key !== '.')) {
					event.preventDefault();
				}
				if ((type === 'datetext' && field.value?.length >= 10) || (type === 'sortcode' && field.value?.length >= 8) || (type === 'accountnumber' && field.value?.length >= 8)) {
					if (event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
						event.preventDefault();
					}
				}
				if (type === 'currency' || type === 'percent') {
					const value = field.value || '';
					const decimalIndex = value.indexOf('.');
					if (decimalIndex !== -1 && value.length - decimalIndex - 1 >= 2 && event.key !== 'Backspace' && event.key !== 'Tab' && event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') {
						event.preventDefault();
					}
				}
			}
		},
		determineDisabled(field) {
			if (field.readOnly && this.editMode) {
				return true;
			}
			return false;
		},
		enableManualEntry(field) {
			field.value = '';
			this.manualEntryFields[field.id] = true;
			this.manualEntryFields = { ...this.manualEntryFields };
		},
		disableManualEntry(field) {
			field.value = null;
			this.manualEntryFields[field.id] = false;
			this.manualEntryFields = { ...this.manualEntryFields };
		}
	},
	mounted: function() {
		this.onLoad();
		this._handleTouchStart = (e) => {
			var activeInput = document.activeElement;
			if (!activeInput || activeInput.tagName !== 'INPUT') return;
			var container = e.target.closest('.v-input, .v-field, .inputSections > div');
			var newInput = e.target.tagName === 'INPUT' ? e.target : (container ? container.querySelector('input') : null);
			if (newInput && newInput !== activeInput) {
				e.preventDefault();
				newInput.focus({ preventScroll: true });
			}
		};
		document.addEventListener('touchstart', this._handleTouchStart, { passive: false });
	},
	beforeUnmount: function() {
		document.removeEventListener('touchstart', this._handleTouchStart);
	}
}
</script>

<style scoped>

h1 {
	font-size: 24px;
	font-weight: 500;
	margin-bottom: 20px;
}

p {
	margin-bottom: 15px;
}

.select-radio-group {
	margin-bottom: -8px;
}

.radio-label {
	font-size: 14px;
	margin-bottom: 8px;
	color: var(--text-color);
}

.select-radio-group :deep(.v-radio-group) {
	margin-top: 0;
}

.select-radio-group :deep(.v-selection-control-group) {
	gap: 16px;
}

/* Position clear icon where dropdown icon normally appears */
.dropdown-field :deep(.v-field__clearable) {
	margin-inline-end: 0;
}

/* Disable transition on clear icon */
.inputSections :deep(.v-field__clearable),
.inputSections :deep(.v-field__clearable *),
.inputSections :deep(.v-field__append-inner),
.inputSections :deep(.v-field__append-inner *) {
	transition: none !important;
	animation: none !important;
}

/* Align date field clear icon with others */
.inputSections :deep(.v-text-field .v-field__clearable) {
	margin-inline-end: 4px;
}

/* Not listed message and action */
.not-listed {
	margin-top: -8px;
	margin-bottom: 16px;
}

.not-listed p {
	margin-bottom: 2px;
	color: var(--text-color);
}

.not-listed a {
	color: var(--text-color);
	text-decoration: underline;
	font-weight: bold;
}

.not-listed--manual {
	margin-top: -14px;
}

.clear-x {
	width: 16px;
	height: 16px;
}

/* Rounded corners on all fields */
.inputSections :deep(.v-field) {
	border-radius: 8px;
}

/* Reduce spacing between fields */
.inputSections :deep(.v-input) {
	margin-bottom: -8px;
}

/* Help text under fields */
.help-text {
	font-size: 11px;
	margin-top: -12px;
	margin-bottom: 16px;
}

</style>